<div class="center-content">
  <button
    *ngIf="isNotLastPage(); else lastPage"
    class="load-more-button"
    (click)="changeCurrentPage()">
      &darr; Cargar más &darr;
  </button>
  <ng-template #lastPage> No hay más registros</ng-template>
</div>
